export default "__VITE_ASSET__653ec68c__"